import {Component, OnInit} from '@angular/core';
import {FileUploadService} from '../../../services/file-upload-service/file-upload.service';
import {BehaviorSubject} from 'rxjs';
import {FileUploadStatus} from '../../../model/file-upload-status';
import {UploadLocation} from '../../../enum/upload-location';

@Component({
    selector: 'app-proposal-upload-summary',
    templateUrl: './proposal-upload-summary.component.html',
    styleUrls: ['../../../../styles/form-input.scss'],
    standalone: false
})
export class ProposalUploadSummaryComponent implements OnInit {


  riskDescriptionUploadStatus$ = new BehaviorSubject<FileUploadStatus[]>([]);

  riskLocationUploadStatus$ = new BehaviorSubject<FileUploadStatus[]>([]);

  individualClausesConditionsUploadStatus$ = new BehaviorSubject<FileUploadStatus[]>([]);

  previousDamageUploadStatus$ = new BehaviorSubject<FileUploadStatus[]>([]);

  proposalInformationUploadStatus$ = new BehaviorSubject<FileUploadStatus[]>([]);

  constructor(public fileUploadService: FileUploadService) {
  }

  ngOnInit(): void {
    this.fileUploadService.fileUploadStatus$.subscribe(allFileUploads => {
      this.riskDescriptionUploadStatus$.next(allFileUploads.filter(upload => upload.uploadLocation === UploadLocation.RISKDESCRIPTION));
      this.riskLocationUploadStatus$.next(allFileUploads.filter(upload => upload.uploadLocation === UploadLocation.RISKLOCATION));
      this.individualClausesConditionsUploadStatus$.next(allFileUploads.filter(upload => upload.uploadLocation === UploadLocation.INDIVIDUALCLAUSESCONDITIONS));
      this.previousDamageUploadStatus$.next(allFileUploads.filter(upload => upload.uploadLocation === UploadLocation.PREVIOUSDAMAGE));
      this.proposalInformationUploadStatus$.next(allFileUploads.filter(upload => upload.uploadLocation === UploadLocation.PROPOSALINFORMATION));
    });
  }
}
